export function isEditableEventTarget(event: Event): boolean {
  const target = event.target as HTMLElement | null;
  if (!target) return false;
  const tag = target.tagName;
  if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return true;
  if (target.isContentEditable === true) return true;
  if (target.contentEditable === 'true') return true;
  return target.getAttribute?.('contenteditable') === 'true';
}
